export const PWS_COUPONS_URLS = {
    publicGlobalConfig: '/api/v2/pws/coupons/public-config',
    pwsOwnerSettings: '/api/v2/pws/coupons/current-user-pws-profile/coupon-settings'
};

export const PWS_COUPONS_VALIDATION_RULES = {
    customCouponCodeValue: {
        maxLength: 20,
        mustStartWith: 'PWS'
    }
}
